<template>
  <div class="footer">
    <div class="container">
      <div class="footer__inner">
        <div class="footer__text">

          <nav class="footer__links">
            <ul>
                <li v-for="(link, index) in footerMenu" :key="index">
                <Link class="footer__link" :to="this.$root.$i18n.locale === 'ua' ? link.pathUa : link.pathEn" target="_blank">{{ $t(link.name) }}</Link>
              </li>   
              <li>
                <a class="footer__link" :href="this.$root.$i18n.locale === 'ua' ? '/Terms_of_use_ua.pdf' :'/Terms_of_use.pdf' " target="_blank">{{ $t('footer.foo_bar[3]') }}</a>
              </li>
            </ul>
          </nav>

          <div class="footer__copyrights">
            © Webmil Web Production, 2009 — {{this.getCurrentYear()}}. {{$t('footer.reserved')}}
          </div>

        </div>

        <div class="footer__image">
          <a href="https://clutch.co/profile/webmil-web-production#summary" rel="nofollow">
            <img src="../assets/clutch.png" alt="">
          </a>
          <div class="footer__image-text">
            <div class="clutch-widget" data-nofollow="true" data-url="https://widget.clutch.co/" data-widget-type="1" data-height="40" data-clutchcompany-id="47299"></div>
          </div>
        </div>

        <div class="footer__social">
          <div>{{$t('footer.follow_us')}}</div>
          <div class="footer__social-icon">
            <a href="https://www.linkedin.com/company/webmil">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 2.292C0 1.026 1.052 0 2.35 0H29.65C30.948 0 32 1.026 32 2.292V29.708C32 30.974 30.948 32 29.65 32H2.35C1.052 32 0 30.974 0 29.708V2.292ZM9.886 26.788V12.338H5.084V26.788H9.886ZM7.486 10.364C9.16 10.364 10.202 9.256 10.202 7.868C10.172 6.45 9.162 5.372 7.518 5.372C5.874 5.372 4.8 6.452 4.8 7.868C4.8 9.256 5.842 10.364 7.454 10.364H7.486ZM17.302 26.788V18.718C17.302 18.286 17.334 17.854 17.462 17.546C17.808 16.684 18.598 15.79 19.926 15.79C21.664 15.79 22.358 17.114 22.358 19.058V26.788H27.16V18.5C27.16 14.06 24.792 11.996 21.632 11.996C19.084 11.996 17.942 13.396 17.302 14.382V14.432H17.27C17.2806 14.4153 17.2913 14.3986 17.302 14.382V12.338H12.502C12.562 13.694 12.502 26.788 12.502 26.788H17.302Z" fill="#2E3139"/>
              </svg>
            </a>
            <a href="https://www.facebook.com/webmileu">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 0C0.895431 0 0 0.895431 0 2V30C0 31.1046 0.895431 32 2 32H30C31.1046 32 32 31.1046 32 30V2C32 0.895431 31.1046 0 30 0H2ZM23.0195 4.17579C23.2519 4.17085 23.4939 4.1784 23.7441 4.19531C24.6635 4.19656 25.6237 4.27944 26.5762 4.36328L26.4726 8.15235H23.9141C22.7144 8.12579 22.2811 8.59163 22.2422 9.94531V12.9219H26.5762L26.4043 16.9805H22.2422V28.2793H18.0137V16.9805H15.0781V12.9219H18.0137V9.43749C18.0137 6.92525 19.0758 5.32619 21.168 4.51563C21.7053 4.30421 22.3223 4.19059 23.0195 4.17579Z" fill="#2E3139"/>
              </svg>
            </a>
            <a href="https://www.behance.net/Webmil">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M30.72 0H1.28C0.572 0 0 0.572 0 1.28V30.72C0 31.428 0.572 32 1.28 32H30.72C31.428 32 32 31.428 32 30.72V1.28C32 0.572 31.428 0 30.72 0ZM19.46 9.556H24.996V10.904H19.46V9.556ZM16 20.672C15.7411 21.1635 15.3713 21.588 14.92 21.912C14.448 22.24 13.924 22.48 13.368 22.62C12.7863 22.7759 12.1862 22.8526 11.584 22.848H4.96V9.204H11.4C12.052 9.204 12.644 9.264 13.184 9.376C13.72 9.488 14.176 9.68 14.56 9.94C14.94 10.2 15.24 10.548 15.452 10.98C15.66 11.408 15.768 11.944 15.768 12.58C15.768 13.268 15.612 13.836 15.3 14.296C14.984 14.756 14.528 15.128 13.908 15.42C14.752 15.66 15.372 16.088 15.78 16.688C16.196 17.296 16.4 18.024 16.4 18.88C16.4 19.576 16.268 20.172 16 20.672ZM27.152 18.56H20.016C20.016 19.336 20.284 20.08 20.688 20.48C21.096 20.876 21.68 21.076 22.444 21.076C22.996 21.076 23.464 20.936 23.864 20.66C24.26 20.384 24.5 20.092 24.588 19.788H26.98C26.596 20.976 26.012 21.824 25.22 22.336C24.436 22.848 23.476 23.104 22.36 23.104C21.58 23.104 20.88 22.976 20.252 22.732C19.648 22.496 19.104 22.136 18.656 21.672C18.2143 21.1955 17.8728 20.6351 17.652 20.024C17.408 19.348 17.288 18.636 17.296 17.92C17.296 17.18 17.42 16.492 17.66 15.852C18.12 14.608 19.076 13.612 20.296 13.096C20.948 12.824 21.648 12.688 22.356 12.696C23.196 12.696 23.924 12.856 24.556 13.184C25.1644 13.4972 25.6927 13.9461 26.1 14.496C26.504 15.044 26.788 15.668 26.968 16.372C27.14 17.064 27.2 17.792 27.152 18.56ZM22.272 14.736C21.84 14.736 21.476 14.812 21.196 14.96C20.916 15.108 20.684 15.292 20.508 15.504C20.3404 15.7087 20.2165 15.9456 20.144 16.2C20.08 16.412 20.036 16.628 20.02 16.848H24.44C24.376 16.156 24.136 15.644 23.816 15.284C23.48 14.928 22.94 14.736 22.272 14.736ZM12.332 14.332C12.68 14.08 12.848 13.664 12.848 13.092C12.86 12.82 12.804 12.552 12.684 12.308C12.576 12.112 12.416 11.948 12.22 11.832C12.0168 11.7088 11.7911 11.6272 11.556 11.592C11.3 11.544 11.04 11.52 10.784 11.524H7.972V14.712H11.016C11.54 14.716 11.984 14.588 12.332 14.332ZM12.804 17.212C12.412 16.912 11.888 16.764 11.236 16.764H7.964V20.524H11.172C11.472 20.524 11.748 20.496 12.016 20.44C12.284 20.384 12.524 20.288 12.728 20.152C12.932 20.02 13.096 19.84 13.22 19.608C13.34 19.376 13.4 19.08 13.4 18.724C13.4 18.016 13.2 17.516 12.804 17.212Z" fill="#2E3139"/>
              </svg>
            </a>
          </div>

          <div class="footer__copyrights-social">
            © Webmil Web Production, 2009 — {{this.getCurrentYear()}}. {{$t('footer.reserved')}}
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>

import Link from "./Link";

export default {
  data() {
    return {
      footerMenu: [
        {name: 'footer.foo_bar[0]', pathUa: '/career/', pathEn: '/career/',},
        {name: 'footer.foo_bar[1]', pathUa: '/Privacy_policy_ua.pdf', pathEn: 'https://www.iubenda.com/privacy-policy/54338031/legal?from_cookie_policy=true&an=no'},
        {name: 'footer.foo_bar[2]', pathUa: '/Cookie_ua.pdf', pathEn: 'https://www.iubenda.com/privacy-policy/54338031/cookie-policy?an=no&s_ck=false&newmarkup=yes'}
      ]
    }
  },
  props: [
    "currentLanguage"
  ],
  methods: {
    getCurrentYear(){
      return new Date().getFullYear()
    },
  },
  components: {
    Link
  },
}
</script>

<style lang="scss">
@import "../base/styles/global";


.footer{
  padding: 52px 0px;
  margin-top: 50px;

  &__inner{
    display: flex;

    @media(max-width: 991px){
      flex-direction: column;
      align-items: center;
    }
  }

  &__text{
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ul{
      list-style: none;
      display: flex;
      @media(max-width: 991px){
        flex-direction: column;
        align-items: center;
      }
    }

    li{
      margin-right: 50px;
      a{
        font-size: 18px;
        line-height: 28px;
        color: #2E3139;

        @media(max-width: 991px){
          font-size: 24px;
          line-height: 30px;
        }
      }

      @media(max-width: 991px){
        margin-bottom: 30px;
        margin-right: 0px;
      }
    }
  }

  &__links {
    a {
      transition: 0.4s all;

      &:hover {
        color: #688E93;
      }
    }
  }

  &__image-text{
    font-size: 14px;
    line-height: 24px;
    color: #454C4F;
    max-width: 130px;
  }

  @media(max-width: 991px){
    &__image{
      text-align: center;
      margin-bottom: 43px;
      margin-top: 12px;
    }
  }

  &__social{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 18px;
    line-height: 28px;
    color: #2E3139;

    div{
      @media(max-width: 991px){
        &:first-letter{
          text-transform: capitalize;
        }
      }
    }

    @media(max-width: 991px){
      text-align: center;
    }

    &-icon{
      display: flex;
      align-items: flex-end;
      margin-top: 10px;

      a{
        display: block;

        svg > path {
          transition: 0.4s fill;
        }
        @media (any-hover: hover) {
          &:hover svg > path{
            fill: #688E93;
          }
        }
      }

      a:not(:last-child){
        margin-right: 28px;
      }

      @media (max-width: 991px){
        justify-content: center;
      }
    }



    @media(min-width: 992px){
      margin-left: 91px;
    }
  }

  .footer__copyrights-social{
    display: none;
    font-size: 12px;
    line-height: 18px;
  }


  &__coptyrights{
    font-size: 12px;
    line-height: 18px;
  }

  @media(max-width: 991px){
    &__copyrights{
      text-align: center;
      display: none;
    }

    .footer__copyrights-social{
      display: block;
      font-size: 14px;
      line-height: 18px;
      margin-top: 46px;
    }
  }




}


</style>
